import baseCompList from '../comp-schema/base-comp-list'
import customCompList from '../comp-schema/custom-comp-list'
import formCompList from '../comp-schema/form-comp-list'
import { chartTypeMapping } from '../comp-schema/chart-comp-list'
import {
  titleCompList,
  contentCompList,
  chartCompList,
  quotaCompList,
  interactCompList
} from '../comp-schema/big-comp-list'
import { threeCompList } from '../comp-schema/3d-comp-list'
import { getApiMenu } from '@haohan/clw-api'
import { useProject } from '@haohan/clw-store'

const chartList = chartTypeMapping['全部']
const Items: { [key: string]: any } = {
  baseCompList,
  customCompList,
  chartList,
  titleCompList,
  contentCompList,
  chartCompList,
  quotaCompList,
  interactCompList,
  formCompList,
  threeCompList
}
import { cloneDeep, has } from 'lodash-es'

export function transOption2TypeObj() {
  const optionObj: { [key: string]: any } = {}
  Object.keys(Items).forEach((key) => {
    Items[key].forEach((op: any) => {
      optionObj[op.type] = op
      optionObj[op.type.substring(2, op.type.length)] = op
    })
  })
  console.log('transOption2TypeObj', optionObj)
  return optionObj
}

function objectHasProperty(obj: any, property: any) {
  return Object.prototype.hasOwnProperty.call(obj, property)
}
/**
 * 更新Attribute外的属性值
 * @param {原组件配置} currentWidget
 * @param {新组件配置} newWidget
 */
function updateWidgetOwnAttribute(currentWidget: any, newWidget: any) {
  const ignoreKeys = [
    'eventOption',
    'attributes',
    'children',
    'type',
    'key',
    'index',
    'events',
    'prop',
    'dataProp',
    'styleProp',
    'formProp',
    'version'
  ]
  Object.keys(newWidget).forEach((key) => {
    if (ignoreKeys.findIndex((ik) => ik === key) === -1) {
      // TODO 不加判断会覆盖原先的值，比如下拉框中，数据源是使用本地还是数据查询
      if (!Object.prototype.hasOwnProperty.call(currentWidget, key)) {
        currentWidget[key] = newWidget[key]
      }
      // 如果值是boolean类型，则使用新的值，主要针对，是否支持交互、数据源配置两个属性
      if (typeof currentWidget[key] === 'boolean') {
        currentWidget[key] = newWidget[key]
      }
    }
  })
  // 删除已不存在得属性
  Object.keys(currentWidget).forEach((key) => {
    if (ignoreKeys.findIndex((ik) => ik === key) === -1) {
      if (!objectHasProperty(newWidget, key)) {
        delete currentWidget[key]
      }
    }
  })
  // 增加新增的属性
  if (!Object.prototype.hasOwnProperty.call(currentWidget, 'events')) {
    currentWidget.events = []
  }
  // 避免旧版本迁移过来后，type 不正确
  currentWidget.type = newWidget.type
}

/**
 * 更新Attribute组件中的值
 * @param {原组件配置} currentWidget
 * @param {新组件配置} newWidget
 */
function updateWidgetAttribute(currentWidget: any, newWidget: Widget) {
  currentWidget.styleProp = { ...newWidget.styleProp, ...currentWidget.styleProp }
  currentWidget.prop = { ...newWidget.prop, ...currentWidget.prop }
  currentWidget.dataProp = { ...newWidget.dataProp, ...currentWidget.dataProp }
  currentWidget.formProp = { ...newWidget.formProp, ...currentWidget.formProp }
  // }
  // TODO: 关于静态数据的处理，有问题
  // 统一本地数据属性，这里需要避免已经修改本地数据源之后，又被重置
  if (
    objectHasProperty(currentWidget.dataProp, 'options') &&
    !objectHasProperty(currentWidget.dataProp, 'defaultData')
  ) {
    currentWidget.dataProp.defaultData = currentWidget.dataProp.options
    delete currentWidget.dataProp.options
  }
}

/**
 * 更新eventOption组件中的值
 * @param {原组件配置} currentWidget
 * @param {新组件配置} newWidget
 */
function updateWidgetEventOption(currentWidget: any, newWidget: any) {
  // 如果不包含属性配置则跳过
  if (
    !objectHasProperty(currentWidget, 'eventOption') &&
    !objectHasProperty(newWidget, 'eventOption')
  ) {
  } else if (
    !objectHasProperty(currentWidget, 'eventOption') &&
    objectHasProperty(newWidget, 'eventOption')
  ) {
    // 如果原先没有该属性则直接赋值
    currentWidget.eventOption = newWidget.eventOption
  } else {
    Object.keys(newWidget.eventOption).forEach((key) => {
      if (!objectHasProperty(currentWidget.eventOption, key)) {
        currentWidget.eventOption[key] = newWidget.eventOption[key]
      }
    })
    // 删除已经不存在得属性
    Object.keys(currentWidget.eventOption).forEach((key) => {
      if (!objectHasProperty(newWidget.eventOption, key)) {
        delete currentWidget.eventOption[key]
      }
    })
    // 更新固定参数
    updateFixedParam(currentWidget.eventOption, newWidget.eventOption, 'send')
    updateFixedParam(currentWidget.eventOption, newWidget.eventOption, 'receive')
  }
}

function updateFixedParam(currentObj: any = {}, newObj: any = {}, param = '') {
  if (!newObj[param]) {
    return
  }
  Object.keys(newObj[param]).forEach((sKey) => {
    if (!objectHasProperty(currentObj[param], sKey)) {
      currentObj[param][sKey] = newObj[param][sKey]
    } else {
      newObj[param][sKey].forEach((list: any) => {
        const cIndex = currentObj[param][sKey].findIndex((cat: any) => cat.label === list.label)
        if (cIndex === -1) {
          currentObj[param][sKey].push(list)
        } else {
          currentObj[param][sKey][cIndex].value = list.value
        }
      })
    }
  })
  // 删除旧有已不存在得配置
  Object.keys(currentObj[param]).forEach((sKey) => {
    if (!objectHasProperty(newObj[param], sKey)) {
      delete currentObj[param][sKey]
    } else {
      const _list: any = []
      currentObj[param][sKey].forEach((list: any) => {
        const cIndex = newObj[param][sKey].findIndex((cat: any) => cat.label === list.label)
        if (cIndex !== -1) {
          _list.push(list)
        }
      })
      currentObj[param][sKey] = _list
    }
  })
}
/**
 * 2.6.3 API接口
 * 更新组件数据源为API接口时，将API接口定义中的值赋值到组件的dataProp.apiDataPath
 * @param currentWidget 当前组件
 */
async function updateApiDataPath(currentWidget: Widget) {
  if (currentWidget.dataSourceType === 'CustomApi' && currentWidget.dataProp.tableId) {
    // 查找对应API
    const projectStore = useProject()
    const { data } = await getApiMenu(
      projectStore.currentProject.id,
      currentWidget.dataProp.tableId
    )
    const dataPath =
      data.responseDefine && data.responseDefine.dataPath
        ? data.responseDefine.dataPath
        : 'data.content'
    currentWidget.dataProp.apiDataPath = dataPath
  }
  const BODY_REPLACE_PARAM = 'REQUEST_BODY'
  // 更新组件事件中绑定API参数的 body 值 REQUEST_BODY
  // 获得组件中所有的发送事件eventType = 'send'  behavior='api' apiParam.bindApiParam
  if (objectHasProperty(currentWidget, 'events') && currentWidget.events.length > 0) {
    currentWidget.events.forEach((event: WidgetEvent) => {
      if (
        event.eventType === 'send' &&
        event.behavior === 'api' &&
        event.apiParam &&
        event.apiParam.bindApiParam === 'body'
      ) {
        event.apiParam.bindApiParam = BODY_REPLACE_PARAM
      }
    })
  }
}

/**
 * 更新组件配置
 * updateWidgetOwnAttribute 更新其他属性
 * updateWidgetAttribute 针对attributes，不更改原先得值，如果有新增加得属性，则增加属性
 * updateWidgetEventOption 针对eventOption，如果存在则更新，不存在则添加
 * @param {该页面组件集合} widgetDataList
 */
export function updatePageOptionByNewOption(widgetDataList: any, formComp?: any) {
  const allComps = formComp ? formComp : transOption2TypeObj()
  // 获得需要更新的内容
  widgetDataList.forEach(async (wdl: any) => {
    if (wdl.type) {
      const compDetail = allComps[wdl.type]
      // 获得当前类型对应得配置项数据
      // console.log('wdl.type', wdl, compDetail)
      // return false
      if (compDetail) {
        const typeObj = cloneDeep(compDetail)
        // console.log('typeObj', typeObj)
        if (typeObj) {
          updateWidgetOwnAttribute(wdl, typeObj)
          updateWidgetAttribute(wdl, typeObj)
          updateWidgetEventOption(wdl, typeObj)
          // 更新2.6.3版本的API接口 responseDefine.dataPath
          await updateApiDataPath(wdl)
        }
      }
    }
    if (wdl.children && wdl.children.length > 0) {
      if (wdl.type === 'BigScreenContent') {
        wdl.children.forEach((ch: any) => {
          updatePageOptionByNewOption([ch.widget], allComps)
        })
      } else {
        wdl.children.forEach((ch: any) => {
          updatePageOptionByNewOption(ch.list, allComps)
        })
      }
    }
    if (
      wdl.type &&
      ['HHTabPaneWidget', 'FormStep', 'FormTabPane', 'BigScreenPanel'].includes(wdl.type)
    ) {
      const item = wdl.dataProp.defaultData
      item?.forEach((v: any) => {
        updatePageOptionByNewOption(v.list, allComps)
      })
    }
  })
  console.log('updatePageOptionByNewOption 执行完毕')
}

/**
 * 僵木蠕v1-v2升级补充脚本
 * 只针对
 * 1. 时间组件
 * 2. 条件筛选组件
 * @param widgetDataList 该页面组件集合
 */
export function transJMRAttribute(widgetDataList: any) {
  const types = ['HHCustomQuery', 'HHDatetimePicker']
  // 获得需要更新的内容
  widgetDataList.forEach(async (wdl: any) => {
    if (wdl.type && types.includes(wdl.type)) {
      // 将交互的值设置为字符串
      // 查找出所有发送事件
      const sendEvents = wdl.events.filter((event: any) => event.eventType === 'send')
      if (sendEvents.length > 0 && wdl.type === 'HHDatetimePicker') {
        // 时间组件处理
        sendEvents.forEach((event: WidgetEvent) => {
          const { bindValue } = event
          if (bindValue && bindValue === 'dateTime' && !has(event, 'bindValueType')) {
            event.bindValueType = 'string'
          }
        })
      } else if (sendEvents.length > 0 && wdl.type === 'HHCustomQuery') {
        // 条件筛选组件处理
        const { prop } = wdl
        if (has(prop, 'conditions') && prop.conditions.length > 0) {
          prop.conditions.forEach((condition: any) => {
            if (['time', 'select'].includes(condition.type) && !has(condition, 'eventValueType')) {
              if (condition.type === 'select' && condition.multiple) {
                condition.eventValueType = 'string'
              } else if (condition.type === 'time') {
                condition.eventValueType = 'string'
              }
            }
          })
        }
      }
    }
    if (wdl.children && wdl.children.length > 0) {
      wdl.children.forEach((ch: any) => {
        transJMRAttribute(ch.list)
      })
    }
    if (wdl.type && wdl.type.includes('TabPane')) {
      const item = wdl.dataProp.defaultData
      item?.forEach((v: any) => {
        transJMRAttribute(v.list)
      })
    }
  })
}
/**
 * 更新指定组件的属性
 * @param widget 当前组件
 */
export function updateByWidget(widget: any) {
  const allComps = transOption2TypeObj()
  const compDetail = allComps[widget.type]
  // 获得当前类型对应得配置项数据
  // console.log('wdl.type', wdl, compDetail)
  // return false
  if (compDetail) {
    const typeObj = cloneDeep(compDetail)
    // console.log('typeObj', typeObj)
    if (typeObj) {
      updateWidgetOwnAttribute(widget, typeObj)
      updateWidgetAttribute(widget, typeObj)
      updateWidgetEventOption(widget, typeObj)
    }
  }
}

export default {
  transOption2TypeObj,
  updatePageOptionByNewOption,
  transJMRAttribute
}
